export default class CountUp {
  constructor(goalCount, onProgress, onComplete, duration = 5000) {
    this.startTime = 0;
    this.beforeValue = 0;
    this.timer = null;

    const progress = (time, start, goal) => {
      if (time < 0) return start;
      if (time >= duration) return goal;
      const value = Math.floor(
        -goal * Math.cos((time / duration) * Math.PI) + goal + start
      );
      if (value >= goal) return goal;
      return value;
    };

    const counter = timestamp => {
      if (!this.startTime) this.startTime = performance.now();
      const time = performance.now() - this.startTime;
      const count = progress(time, 0, goalCount);
      const isGoal = count >= goalCount;

      if (this.beforeValue === count && !isGoal) {
        this.timer = window.requestAnimationFrame(counter);
        return;
      }
      this.beforeValue = count;

      onProgress(count);
      if (!isGoal) this.timer = window.requestAnimationFrame(counter);
      if (isGoal && onComplete) onComplete();
    };

    this.timer = window.requestAnimationFrame(counter);
  }

  stop() {
    if (this.timer) window.cancelAnimationFrame(this.timer);
  }
}
